var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatsCircleIcon = function SvgChatsCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.664 10.992a5.633 5.633 0 1 1 1.969 1.969l-1.945.555a.47.47 0 0 1-.579-.578z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.195 13.742a5.617 5.617 0 0 0 8.172 2.969v0l1.945.555a.469.469 0 0 0 .579-.578l-.555-1.946a5.618 5.618 0 0 0-4.531-8.484"
  })));
};
export default SvgChatsCircleIcon;